import styled from 'styled-components';

export const ReviewTradeContent = styled.div`
  margin-top: 68px;
  margin-bottom: 124px;
`;

export const ReviewTradeText = styled.span`
  color: #183b56;
`;

export const ReviewTradeMakeSureText = styled.p`
  font-size: 1.75rem;
  font-weight: 600;
  color: #183b56;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
`;

export const ReviewTradeBlockWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
  margin-top: 32px;
`;

export const ReviewTradeSubtitle = styled.h5`
  color: #74899a;
  font-size: 2rem;
  font-weight: 600;
`;

export const ReviewTradeTokensWrapper = styled.div`
  display: grid;
  grid-gap: 22px;
  grid-template-columns: repeat(auto-fill, minmax(290px, 1fr));
`;

export const TokenWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  background: #ffffff;
  border-radius: 16px;
  height: 382px;
  width: 100%;
`;

export const TokenImage = styled.img`
  width: 100%;
  height: 302px;
  object-fit: contain;
  border-radius: 16px 16px 0 0;

  &.no-image {
    width: 70%;
    height: 100%;
    max-height: 302px;
  }
`;

export const TokenImageCurrency = styled.img`
  max-height: 160px;
  max-width: 160px;
  height: 50%;
  margin: 0 auto;
  margin-top: 34px;
`;

export const TokenContent = styled.div`
  width: 100%;
  height: 20%;
  padding: 8px 16px;
`;

export const TokenCurrencyWrapper = styled.div`
  height: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const TokenTitle = styled.h5`
  color: #183b56;
  font-weight: 600;
  margin: 8px 0;
  font-size: 1rem;
  text-align: center;
`;

export const TokenAmount = styled.span`
  color: #183b56;
  font-weight: 600;
  font-size: 1rem;
  margin: 8px 0;
`;

export const TokenAmountCurrency = styled.span`
  color: #183b56;
  font-weight: 600;
  font-size: 2rem;
  margin: 8px 0;
  text-align: center;
  width: 100%;
  word-wrap: break-word;
`;

export const TokenUpperContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const TokenNumbering = styled.span`
  font-size: 0.875rem;
  color: #183b56;
`;

export const LoadingContainer = styled.div`
  width: 100%;
  height: 80%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const WalletIcon = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  overflow: hidden;
  margin-left: 36px;
`;

export const AccountText = styled.span`
  color: #183b56;
  font-size: 16px;
  font-weight: 500;
  margin-left: 4px;
`;

export const TransactionHash = styled.span`
  margin-left: 4px;
  cursor: pointer;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  text-decoration-line: underline;
  border-bottom: 1px solid #18a0fb;
  background: linear-gradient(180deg, #566ffe 0%, #18a0fb 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  //background-clip: text;
  text-fill-color: transparent;
  margin-left: 25px;
`;

export const BackButtonWrapper = styled.div`
  margin-bottom: 18px;
`;

export const BackButton = styled.button`
  cursor: pointer;
  background: #ffffff;
  border: 1px solid #e3e7eb;
  border-radius: 40px;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #183b56;
  width: 78px;
  height: 40px;
  transition: all 0.2s ease-in-out;

  &:hover {
    opacity: 0.8;
  }
`;

export const VerifyIcon = styled.img`
  width: 14px;
  height: 14px;
`;
